export default __webpack_public_path__ + "static/media/winner.357c8359.jpeg";